import { render, staticRenderFns } from "./RetentionPolicyList.vue?vue&type=template&id=db4dcdde&"
import script from "./RetentionPolicyList.vue?vue&type=script&lang=js&"
export * from "./RetentionPolicyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports